import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useListCarryLeaves({ props = {} , config = {}}) {
  const { rowsPerPage } = useApp();

  const { data, isLoading, isRefetching, isFetching, refetch } = useList(
    'employeeold_leave_count_details',
    {...props},
    {...config}
  );

  return {
    data: data?.data?.data || [],
    count: data?.data?.count,
    isLoading: isLoading || isRefetching || isFetching,
    refetch,
  };
}
